import tilePalermoCataniaMessina01 from "assets/medium/PALERMO-CATANIA-MESSINA/01.jpg";
import tilePalermoCataniaMessina02 from "assets/medium/PALERMO-CATANIA-MESSINA/02.jpg";
import tilePalermoCataniaMessina03 from "assets/medium/PALERMO-CATANIA-MESSINA/03.jpg";
import tilePalermoCataniaMessina04 from "assets/medium/PALERMO-CATANIA-MESSINA/04.jpg";
import tilePalermoCataniaMessina05 from "assets/medium/PALERMO-CATANIA-MESSINA/05.jpg";
import tilePalermoCataniaMessina06 from "assets/medium/PALERMO-CATANIA-MESSINA/06.jpg";
import tilePalermoCataniaMessina07 from "assets/medium/PALERMO-CATANIA-MESSINA/07.jpg";
import tilePalermoCataniaMessina08 from "assets/medium/PALERMO-CATANIA-MESSINA/08.jpg";
import tilePalermoCataniaMessina09 from "assets/medium/PALERMO-CATANIA-MESSINA/09.jpg";
import tilePalermoCataniaMessina10 from "assets/medium/PALERMO-CATANIA-MESSINA/10.jpg";
import tilePalermoCataniaMessina11 from "assets/medium/PALERMO-CATANIA-MESSINA/11.jpg";
import tilePalermoCataniaMessina12 from "assets/medium/PALERMO-CATANIA-MESSINA/12.jpg";
import tilePalermoCataniaMessina13 from "assets/medium/PALERMO-CATANIA-MESSINA/13.jpg";
import tilePalermoCataniaMessina14 from "assets/medium/PALERMO-CATANIA-MESSINA/14.jpg";
import tilePalermoCataniaMessina15 from "assets/medium/PALERMO-CATANIA-MESSINA/15.jpg";
import tilePalermoCataniaMessina16 from "assets/medium/PALERMO-CATANIA-MESSINA/16.jpg";
import tilePalermoCataniaMessina17 from "assets/medium/PALERMO-CATANIA-MESSINA/17.jpg";
import tilePalermoCataniaMessina18 from "assets/medium/PALERMO-CATANIA-MESSINA/18.jpg";
import tilePalermoCataniaMessina19 from "assets/medium/PALERMO-CATANIA-MESSINA/19.jpg";
import tilePalermoCataniaMessina20 from "assets/medium/PALERMO-CATANIA-MESSINA/20.jpg";
import tilePalermoCataniaMessina21 from "assets/medium/PALERMO-CATANIA-MESSINA/21.jpg";
import tilePalermoCataniaMessina22 from "assets/medium/PALERMO-CATANIA-MESSINA/22.jpg";
import tilePalermoCataniaMessina23 from "assets/medium/PALERMO-CATANIA-MESSINA/23.jpg";
import tilePalermoCataniaMessina24 from "assets/medium/PALERMO-CATANIA-MESSINA/24.jpg";
import tilePalermoCataniaMessina25 from "assets/medium/PALERMO-CATANIA-MESSINA/25.jpg";
import fullImage from "assets/medium/PALERMO-CATANIA-MESSINA/complete.jpg";

import { ILevel, LevelDifficulties, LevelTypes } from "models";

export const palermoCataniaMessina: ILevel = {
  difficulty: LevelDifficulties.medium,
  type: LevelTypes.roadSign,
  name: "Palermo - Catania - Messina",
  fullImage,
  successDialogContent: {
    subtitle: "Hai completato la linea PALERMO - CATANIA - MESSINA",
    link: `https://www.palermocataniamessina.it/content/fsipalermocataniamessina/it.html`,
    contents: [
      {
        text: "Il nuovo collegamento ",
        isBold: false,
      },
      {
        text: "promuoverà gli spostamenti su ferro",
        isBold: true,
      },
      {
        text:
          " di persone e merci all’interno dell’isola. Gli interventi consentiranno di ",
        isBold: false,
      },
      {
        text: "aumentare il numero dei treni",
        isBold: true,
      },
      {
        text: ", innalzare la velocità, ",
        isBold: false,
      },
      {
        text: "ridurre i tempi",
        isBold: true,
      },
      {
        text:
          " di percorrenza e accorciare così le distanze fra l’entroterra e le tre città costiere. A lavori ultimati, il ",
        isBold: false,
      },
      {
        text: "viaggio tra Messina e Catania",
        isBold: true,
      },
      {
        text: " sarà coperto in ",
        isBold: false,
      },
      {
        text: "45 minuti",
        isBold: true,
      },
      {
        text:
          ", contro i 70 minuti di oggi, e quello tra Catania e Palermo in 1 ora e 50 minuti, con un ",
        isBold: false,
      },
      {
        text: "risparmio di circa 1 ora",
        isBold: true,
      },
      {
        text: " rispetto alle tempistiche attuali.",
        isBold: false,
      },
    ],
  },
  tiles: [
    tilePalermoCataniaMessina01,
    tilePalermoCataniaMessina02,
    tilePalermoCataniaMessina03,
    tilePalermoCataniaMessina04,
    tilePalermoCataniaMessina05,
    tilePalermoCataniaMessina06,
    tilePalermoCataniaMessina07,
    tilePalermoCataniaMessina08,
    tilePalermoCataniaMessina09,
    tilePalermoCataniaMessina10,
    tilePalermoCataniaMessina11,
    tilePalermoCataniaMessina12,
    tilePalermoCataniaMessina13,
    tilePalermoCataniaMessina14,
    tilePalermoCataniaMessina15,
    tilePalermoCataniaMessina16,
    tilePalermoCataniaMessina17,
    tilePalermoCataniaMessina18,
    tilePalermoCataniaMessina19,
    tilePalermoCataniaMessina20,
    tilePalermoCataniaMessina21,
    tilePalermoCataniaMessina22,
    tilePalermoCataniaMessina23,
    tilePalermoCataniaMessina24,
    tilePalermoCataniaMessina25,
  ],
};
